/* Whiskey Pop — phone record player, every page (markup: snippets/wp-player.liquid).
   On the jukebox page it plays through the machine's own title strips so wp-juke.js stays in charge
   there; everywhere else it plays the track list itself. A page change stops the audio (Shopify loads
   a new page), so the track and second are kept in sessionStorage and one tap on the record carries on. */
(function () {
  var root = document.querySelector('[data-wprp]');
  var audio = document.getElementById('wp-juke-audio');
  var data = document.getElementById('wpp-data');
  if (!root || !audio || !data) return;
  var tracks = []; try { tracks = JSON.parse(data.textContent); } catch (e) {}
  if (!tracks.length) return;
  root.hidden = false;

  var q = function (s) { return root.querySelector(s); };
  var rec = q('[data-wprp-rec]'), spin = q('[data-wprp-spin]'), card = q('[data-wprp-card]'), dock = q('[data-wprp-dock]');
  var main = q('[data-wprp-main]'), list = q('[data-wprp-list]'), prog = q('[data-wprp-prog]'), fill = q('.wprp__fill');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-wprp-i]'));
  var juke = document.querySelector('[data-juke]');
  var strips = juke ? Array.prototype.slice.call(juke.querySelectorAll('[data-track]')) : [];
  var SKEY = 'wp-player';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var idx = 0, open = false, resumeAt = 0, interrupted = false, pendingSeek = null;

  function fmt(s) { if (!isFinite(s) || s < 0) return '--:--'; s = Math.floor(s); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function vh() {   /* the layout's frozen small-viewport height, so the record doesn't drift as the toolbar collapses */
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-vh'));
    return v > 200 ? v : (window.innerHeight || document.documentElement.clientHeight);
  }
  function abs(u) { try { return new URL(u, location.href).href; } catch (e) { return u; } }

  /* ---- where the record sits: one fixed height. The record never moves up or down (animating `top`
     was choppy on phones); if the card would run off screen it shifts inside its own transform. ---- */
  var NAV = 96, PAD = 16;
  function place() {
    var r = rec.offsetHeight || 132, y = Math.min(Math.max(vh() * 0.58, NAV + r / 2), vh() - r / 2 - PAD);
    var h = card.offsetHeight, c = Math.min(Math.max(y, NAV + h / 2), vh() - h / 2 - PAD);
    dock.style.top = Math.round(y) + 'px';
    root.style.setProperty('--cy', Math.round(c - y) + 'px');
  }

  /* ---- spin: 45 rpm while playing, coasts down on pause, spins back up on play ---- */
  var anim = null, rate = 0, raf = 0;
  if (!reduced && spin.animate) {
    anim = spin.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 1333, iterations: Infinity });
    anim.playbackRate = 0; anim.pause();
  }
  function ramp(to) {
    if (!anim) return; cancelAnimationFrame(raf);
    var from = rate, t0 = performance.now(), dur = to > from ? 400 : 800;
    if (to > 0) anim.play();
    (function step(now) {
      var k = Math.min((now - t0) / dur, 1), e = to > from ? 1 - Math.pow(1 - k, 2) : 1 - Math.pow(1 - k, 3);
      rate = from + (to - from) * e; anim.playbackRate = Math.max(rate, 0.0001);
      if (k < 1) raf = requestAnimationFrame(step); else if (to === 0) anim.pause();
    })(t0);
  }

  /* ---- show / paint ---- */
  function show() { document.documentElement.classList.add('wpp-on'); }
  function playing() { return !audio.paused && !!audio.getAttribute('src'); }
  function paint() {
    if (juke) { var cued = juke.querySelector('[data-track].is-cued'); if (cued && document.body.classList.contains('wpj-has-track')) idx = strips.indexOf(cued); }
    var t = tracks[idx] || tracks[0];
    q('[data-wprp-code]').textContent = t.code; q('[data-wprp-code2]').textContent = t.code;
    q('[data-wprp-title]').textContent = t.title; q('[data-wprp-artist]').textContent = t.artist;
    var img = q('[data-wprp-art]'); if (t.art && img.getAttribute('src') !== t.art) { img.src = t.art; img.alt = t.title + ' record sleeve'; }
    items.forEach(function (li) { li.classList.toggle('is-on', +li.getAttribute('data-wprp-i') === idx); });
    var on = playing();
    root.classList.toggle('is-playing', on); document.documentElement.classList.toggle('wpp-playing', on);
    root.classList.toggle('is-interrupted', interrupted && !on);
    q('[data-wprp-toggle]').setAttribute('aria-label', on ? 'Pause' : 'Play');
    if (!audio.getAttribute('src') || !audio.duration) {   /* fresh page: show where the record was left */
      q('[data-wprp-cur]').textContent = fmt(resumeAt); q('[data-wprp-dur]').textContent = t.time || '--:--';
      var tot = durOf(t); fill.style.setProperty('--p', tot ? Math.min(resumeAt / tot * 100, 100) + '%' : '0%');
    }
    ramp(on ? 1 : 0);
    mediaSession(t);
  }
  function durOf(t) { var m = (t.time || '').match(/^(\d+):(\d\d)$/); return m ? +m[1] * 60 + +m[2] : 0; }

  /* ---- playing a record (always called straight from a tap: iOS needs the gesture) ---- */
  function start(i, at) {
    idx = (i + tracks.length) % tracks.length; interrupted = false; resumeAt = 0; show();
    var t = tracks[idx], fresh = abs(audio.getAttribute('src') || '') !== abs(t.src);
    /* a new file seeks once its metadata is in; the same file (paused in place) just carries on */
    pendingSeek = fresh ? (at || null) : null;
    if (!fresh && at) { try { audio.currentTime = at; } catch (e) {} }
    if (juke && strips[idx]) { strips[idx].click(); paint(); return; }   /* the machine plays it */
    if (fresh) { audio.setAttribute('src', t.src); audio.load(); }
    audio.play().catch(function () {});
    paint(); save();
  }
  function toggle() {
    if (playing()) { audio.pause(); return; }
    if (!audio.getAttribute('src') || interrupted) { start(idx, resumeAt); return; }
    audio.play().catch(function () {});
  }
  function step(d) { if (d < 0 && audio.currentTime > 3) { audio.currentTime = 0; return; } start(idx + d, 0); }

  audio.addEventListener('loadedmetadata', function () {
    if (pendingSeek) { try { audio.currentTime = pendingSeek; } catch (e) {} pendingSeek = null; }
    q('[data-wprp-dur]').textContent = fmt(audio.duration);
  });
  audio.addEventListener('play', function () { show(); paint(); save(); });
  audio.addEventListener('pause', function () { paint(); save(); });
  audio.addEventListener('ended', function () { if (!juke) start(idx + 1, 0); });   /* the machine queues its own next record */
  audio.addEventListener('loadstart', function () { if (pendingSeek) return; fill.style.setProperty('--p', '0%'); q('[data-wprp-cur]').textContent = '0:00'; });
  var lastSave = 0;
  audio.addEventListener('timeupdate', function () {
    if (!audio.duration) return;
    var p = (audio.currentTime / audio.duration) * 100;
    if (!seeking) fill.style.setProperty('--p', p + '%');
    prog.setAttribute('aria-valuenow', Math.round(p));
    q('[data-wprp-cur]').textContent = fmt(audio.currentTime);
    var now = Date.now(); if (now - lastSave > 1000) { lastSave = now; save(); }
  });
  if (juke && 'MutationObserver' in window) {   /* picks made on the machine itself (strips, sleeves, keypad) */
    var l = juke.querySelector('.wpn__list');
    if (l) new MutationObserver(function () { if (document.body.classList.contains('wpj-has-track')) { show(); paint(); } }).observe(l, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---- carry the record across pages ---- */
  function save() {
    if (!document.documentElement.classList.contains('wpp-on')) return;
    var t = audio.getAttribute('src') ? audio.currentTime : resumeAt;
    try { sessionStorage.setItem(SKEY, JSON.stringify({ i: idx, t: Math.floor(t || 0), on: playing() || interrupted })); } catch (e) {}
  }
  window.addEventListener('pagehide', save);
  /* In-app browsers (Instagram, Facebook, the Shopify app's theme preview) can't play audio in the
     background: iOS kills the page and the app shows "Page Error". Pause on the way out there and
     leave the record waiting with the resume cue. Safari and Chrome (UA carries "Safari/") keep playing. */
  var ua = navigator.userAgent || '';
  var inApp = (/iPhone|iPad|iPod/.test(ua) && !/Safari\//.test(ua)) || /Instagram|FBAN|FBAV|Shopify|Line\/|Twitter|Snapchat|TikTok|musical_ly/i.test(ua);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden || !inApp || !playing()) return;
    resumeAt = audio.currentTime; interrupted = true; audio.pause(); paint(); save();
  });
  (function restore() {
    var st = null; try { st = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (e) {}
    if (!st || !tracks[st.i]) return;
    idx = st.i; resumeAt = st.t || 0; interrupted = !!st.on; show(); paint();
  })();

  /* ---- open / tuck away ---- */
  function setOpen(on) {
    open = on; root.classList.toggle('is-open', on);
    rec.setAttribute('aria-expanded', on); rec.setAttribute('aria-label', on ? 'Tuck the player away' : 'Open the record player');
    card.setAttribute('aria-hidden', !on);
    if (!on) showList(false);
  }
  q('[data-wprp-close]').addEventListener('click', function () { setOpen(false); });
  q('[data-wprp-scrim]').addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) setOpen(false); });

  /* ---- swipe the record off the right edge: the music stops and the player leaves ---- */
  function dismiss() {
    root.classList.add('is-gone');
    document.documentElement.classList.remove('wpp-on', 'wpp-playing');   /* first, so the pause below saves nothing */
    audio.pause(); interrupted = false; resumeAt = 0;
    try { sessionStorage.removeItem(SKEY); } catch (e) {}
    setTimeout(function () { root.classList.remove('is-gone'); rec.style.transform = ''; }, 400);
  }

  /* ---- the record: tap to open (or to carry on after a page change), swipe right to send it away ----
     opening waits for the click, not pointerup: the record slides out from under the finger, and
     the click that follows a pointerup would otherwise land on the scrim and shut it again */
  var drag = null, dragged = false;
  rec.addEventListener('pointerdown', function (e) {
    if (open) return;
    drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, on: false };
  });
  rec.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
    if (!drag.on) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   /* a scroll, not a swipe */
      if (dx < 8) return;
      drag.on = true; root.classList.add('is-swiping'); try { rec.setPointerCapture(e.pointerId); } catch (er) {}
    }
    drag.dx = Math.max(0, dx); rec.style.transform = 'translateX(' + drag.dx + 'px)';
  });
  function endDrag(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag; drag = null; dragged = d.on; root.classList.remove('is-swiping');
    if (!d.on) return;
    if (d.dx > 40) dismiss(); else rec.style.transform = '';
  }
  rec.addEventListener('pointerup', endDrag);
  rec.addEventListener('pointercancel', endDrag);
  rec.addEventListener('click', function () {
    if (dragged) { dragged = false; return; }
    if (interrupted && !open) { start(idx, resumeAt); return; }
    setOpen(!open);
  });

  /* ---- swipe the card right to tuck it away ---- */
  var sw = null;
  card.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button,[data-wprp-prog],.wprp__tracks')) return;
    sw = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0 };
  });
  card.addEventListener('pointermove', function (e) {
    if (!sw || e.pointerId !== sw.id) return;
    sw.dx = Math.max(0, e.clientX - sw.x0);
    if (sw.dx > 6 && Math.abs(e.clientY - sw.y0) < sw.dx) { root.classList.add('is-swiping'); card.style.transform = 'translate(' + sw.dx + 'px,calc(-50% + var(--cy,0px)))'; }
  });
  function endSwipe(e) {
    if (!sw || e.pointerId !== sw.id) return;
    var dx = sw.dx; sw = null; root.classList.remove('is-swiping'); card.style.transform = '';
    if (dx > 70) setOpen(false);
  }
  card.addEventListener('pointerup', endSwipe);
  card.addEventListener('pointercancel', endSwipe);

  /* ---- transport ---- */
  q('[data-wprp-toggle]').addEventListener('click', toggle);
  q('[data-wprp-prev]').addEventListener('click', function () { step(-1); });
  q('[data-wprp-next]').addEventListener('click', function () { step(1); });

  var seeking = false;
  function seekTo(x) { var r = prog.getBoundingClientRect(), k = Math.min(Math.max((x - r.left) / r.width, 0), 1); fill.style.setProperty('--p', k * 100 + '%'); return k; }
  prog.addEventListener('pointerdown', function (e) { if (!audio.duration) return; seeking = true; try { prog.setPointerCapture(e.pointerId); } catch (er) {} seekTo(e.clientX); });
  prog.addEventListener('pointermove', function (e) { if (seeking) seekTo(e.clientX); });
  prog.addEventListener('pointerup', function (e) { if (!seeking) return; seeking = false; audio.currentTime = seekTo(e.clientX) * audio.duration; });
  prog.addEventListener('pointercancel', function () { seeking = false; });
  prog.addEventListener('keydown', function (e) {
    if (!audio.duration) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); audio.currentTime = Math.max(0, audio.currentTime - 5); }
  });

  /* ---- tracklist ---- */
  function showList(on) {   /* swap views inside the same box (visibility, not display) so the card keeps its size */
    card.classList.toggle('is-list', on); list.setAttribute('aria-hidden', !on); main.setAttribute('aria-hidden', on);
    if (on) list.querySelector('.wprp__tracks').scrollTop = 0;
  }
  q('[data-wprp-listbtn]').addEventListener('click', function () { showList(true); });
  q('[data-wprp-listclose]').addEventListener('click', function () { showList(false); });
  items.forEach(function (li) { li.querySelector('button').addEventListener('click', function () { start(+li.getAttribute('data-wprp-i'), 0); showList(false); }); });

  /* ---- the header 45 (and any [data-wpp-play]) puts the nickel in: music starts right there; tapped while playing, it opens the card ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wpp-play]'); if (!b) return;
    if (window.matchMedia && !matchMedia('(max-width: 860px)').matches) return;   /* desktop follows the link */
    e.preventDefault();
    var i = +b.getAttribute('data-wpp-play') || 0;
    if (playing()) { setOpen(true); return; }
    start(interrupted ? idx : i, interrupted ? resumeAt : 0);
  });

  /* ---- lock screen: off the jukebox page the machine isn't there to fill it in ---- */
  function mediaSession(t) {
    if (juke || !('mediaSession' in navigator)) return;
    try {
      navigator.mediaSession.metadata = new MediaMetadata({ title: t.title, artist: t.artist, album: 'The Whiskey Pop Jukebox', artwork: t.art ? [{ src: abs(t.art), sizes: '400x400' }] : [] });
      navigator.mediaSession.setActionHandler('play', toggle);
      navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
      navigator.mediaSession.setActionHandler('previoustrack', function () { step(-1); });
      navigator.mediaSession.setActionHandler('nexttrack', function () { step(1); });
    } catch (e) {}
  }

  window.addEventListener('resize', place);
  place(); paint();
})();
